import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

export default function UserDetailCell(cellData) {

    var path = '/users/userDetails';

    if (cellData.data.userRoleId == 1 || cellData.data.userRoleId == 3 || cellData.data.userRoleId == 4) {
        path = '/users/clientDetails';
    }

    return (
        <Link to={{
            pathname: path,
            state: {
                data: cellData.data               
            }
        }}><span className="dx-icon-edit"></span> Управление...</Link>
    );
}


// WEBPACK FOOTER //
// ./App/containers/users/detailCell.jsx